import React from 'react';
import { Text } from '@paypalcorp/pp-react';
import { localsMessages } from '../utility/getTemplateData';

const messages = localsMessages('buttons/partner') || {}
const {
	landing: {
		mayNotBeTaxDeductible
	} = {}
} = messages;

export default function NotTaxDeductibleLegalText() {
	return (
		<Text
			size="sm"
			medium
			style={{
				color: '#687173',
				textAlign: 'center'
			}}
		>{mayNotBeTaxDeductible}</Text>
	)
}
